// Picks which enrollment to open when a course-level deep-link resolves for a
// user who may hold several enrollments for the same course (multi-company
// recognition, periodic re-enrollment, a cancelled + a fresh one, …).
//
// Priority: an in-progress enrollment first, then expired, then completed, and
// only a cancelled one as a last resort so the link never dead-ends. Ties break
// toward the most recently created enrollment (highest id).

export interface PickableEnrollment {
  id: number;
  status: string;
}

const STATUS_PRIORITY: Record<string, number> = {
  active: 0,
  expired: 1,
  completed: 2,
  cancelled: 3,
};

export function pickEnrollmentForCourse<T extends PickableEnrollment>(enrollments: T[]): T | null {
  if (enrollments.length === 0) return null;
  return [...enrollments].sort((a, b) => {
    const pa = STATUS_PRIORITY[a.status] ?? 9;
    const pb = STATUS_PRIORITY[b.status] ?? 9;
    if (pa !== pb) return pa - pb;
    return b.id - a.id;
  })[0]!;
}
